<p-toast></p-toast>

<p-toolbar styleClass="p-mb-4">
    <ng-template pTemplate="left">
        <button pButton pRipple label="{{lbl_go_Back}}" icon="pi pi-chevron-left" class="p-button-warning p-mr-2"
            (click)="goBack()"></button>
    </ng-template>
</p-toolbar>

<div class="card">

    <div class="p-grid">
        <div class="p-col-12 p-md-6">
            <div class="card">
                <div class="p-fluid">
                    <h5>{{lbl_change_password}}</h5>
                    <div class="p-field p-float-label">
                        <input type="password" aria-describedby="current-help" pInputText [(ngModel)]="currentPassword">
                        <label for="float-input">{{lbl_current}} {{lbl_password}}</label>
                        <small id="current-help" *ngIf="currentPassword.length == 0">{{lbl_entry}} {{lbl_current}}
                            {{lbl_password}}.</small>
                    </div>

                    <div class="p-field p-float-label">
                        <input type="password" pInputText [(ngModel)]="newPassword" aria-describedby="new-help"
                            (onChange)="isValidInformation()">
                        <label for="float-input">{{lbl_new}} {{lbl_password}}</label>
                        <small id="new-help" *ngIf="newPassword.length == 0">{{lbl_entry}} {{lbl_new}}
                            {{lbl_password}}</small>
                    </div>

                    <div class="p-field p-float-label">
                        <input type="password" pInputText [(ngModel)]="confirmNewPassword"
                            aria-describedby="confirm-new-help">
                        <label for="float-input">{{lbl_confirm}} {{lbl_password}}</label>
                        <small id="confirm-new-help" *ngIf="newPassword != confirmNewPassword">{{lbl_new}}
                            {{lbl_password}} {{lbl_does_not_match}}</small>
                    </div>
                </div>
            </div>

            <div class="p-field p-grid">
                <div class="p-mr-2 p-mb-2">
                    <button pButton pRipple type="button" icon="pi pi-plus" label="{{lbl_update}}"
                        class="p-button-raised p-button-success" (click)="confirmUpdatePassword()"></button>
                </div>

            </div>
        </div>
    </div>
</div>




<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>